module.exports = "/images/waze.svg";